/**
 * Generates an error message when a value is null.
 * 
 * @param guardName - The name of the variable being guarded.
 * @returns A formatted error message.
 */
export const nullMessage = (guardName: string): string => `${guardName} is null`;

/**
 * Throws an error if the provided value is null.
 * 
 * @param guardName - The name of the variable being guarded.
 * @param guard - The value to check for null.
 * @throws {Error} Throws an error if `guard` is strictly equal to `null`.
 */
export const throwNull = (guardName: string, guard: any): void => {
  const isNull = guard !== null;
  if (isNull === false) {
    throw new Error(nullMessage(guardName));
  }
}